import { faStar as faStarOutline } from "@fortawesome/free-regular-svg-icons";
import { faCaretDown, faMinus, faPlus, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { Button, ButtonGroup, Col, Container, Row } from "react-bootstrap";
import { PatientVisit } from '../../amplify/appsync/search-patients';
import { isDemoUser } from '../../utils/demo';
import { FILTER_PERIOD_OPTIONS, FILTER_REFERENCE_RANGE_OPTIONS, FILTER_STATISTIC_OPTIONS } from '../filters/DashboardFilterOptions';
import { MultiSelectMenu } from '../filters/MultiSelectMenu';
import { SingleSelectMenu } from '../filters/SingleSelectMenu';
import { PREFERRED_NUMERICS_ORDER, PREFERRED_WAVEFORMS_ORDER } from './DashboardOpts';


/**
 * Filter options
 */
export const FilterBar = (props: {  
    user: any,
    ws: string,
    patientVisit: PatientVisit,
    filterOptions: any,
    numericsData: any,
    updateFilterOptions: any,
    setShowLabsModal: any,
    setShowMedsModal: any,
    setShowOrdersModal: any,
    doubleClickOnTimeline: any,
    zoom: any,
    width: number,
    favoriteInfo: any[],
    setShowFavoriteContextMenu: any,
    setFavoriteContextMenu: any,
}) => {

    const [showPatientVisitSelectorModal, setShowPatientVisitSelectorModal] = useState<any>(false);
    const [filterNumericsShow, setFilterNumericsShow] = useState<any>(false);
    const [filterWaveformsShow, setFilterWaveformsShow] = useState<any>(false);
    const [filterPeriodShow, setFilterPeriodShow] = useState<any>(false);
    const [filterStatisticShow, setFilterStatisticShow] = useState<any>(false);
    const [filterReferenceShow, setFilterReferenceShow] = useState<any>(false);

    const isFavorite = () => {
        return props.favoriteInfo && props.favoriteInfo.filter(fav => fav.favorite_type !== "recent").length > 0;
    }

    return (
        <Container fluid className={isDemoUser(props.user) ? "ed-toolbar-demo" : "ed-toolbar"}>
            <Row className="mt-2 mb-2">
                <Col md={12}>
                    <ButtonGroup className="parameters-group">
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => setFilterNumericsShow(true)}>
                                Numerics {(props.filterOptions["numerics"].length > 0) ? (
                                    <>({props.filterOptions["numerics"].length})</>
                                ) : <></>}{' '}<FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                            {filterNumericsShow && (
                                <MultiSelectMenu
                                    selectedItems={props.filterOptions["numerics"]}
                                    option="numerics"
                                    updateFilterOptions={props.updateFilterOptions}
                                    availableItems={PREFERRED_NUMERICS_ORDER}
                                    setShow={setFilterNumericsShow}
                                />
                            )}
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => setFilterWaveformsShow(true)}>
                                Waveforms {(props.filterOptions["waveforms"].length > 0) ? (
                                    <>({props.filterOptions["waveforms"].length})</>
                                ) : <></>}{' '}<FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                            {filterWaveformsShow && (
                                <MultiSelectMenu
                                    selectedItems={props.filterOptions["waveforms"]}
                                    option="waveforms"
                                    updateFilterOptions={props.updateFilterOptions}
                                    availableItems={PREFERRED_WAVEFORMS_ORDER}
                                    setShow={setFilterWaveformsShow}
                                />
                            )}
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => setFilterPeriodShow(true)}>
                                {FILTER_PERIOD_OPTIONS[props.filterOptions["period"]].name} <FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                            {filterPeriodShow && (
                                <SingleSelectMenu
                                    selectedItem={props.filterOptions["period"]}
                                    option="period"
                                    updateFilterOptions={props.updateFilterOptions}
                                    availableItems={FILTER_PERIOD_OPTIONS}
                                    setShow={setFilterPeriodShow}
                                />
                            )}
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => setFilterStatisticShow(true)}>
                                {FILTER_STATISTIC_OPTIONS[props.filterOptions["statistic"]].name} <FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                            {filterStatisticShow && (
                                <SingleSelectMenu
                                    selectedItem={props.filterOptions["statistic"]}
                                    option="statistic"
                                    updateFilterOptions={props.updateFilterOptions}
                                    availableItems={FILTER_STATISTIC_OPTIONS}
                                    setShow={setFilterStatisticShow}
                                />
                            )}
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => setFilterReferenceShow(true)}>
                                {FILTER_REFERENCE_RANGE_OPTIONS[props.filterOptions["reference"]].name} <FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                            {filterReferenceShow && (
                                <SingleSelectMenu
                                    selectedItem={props.filterOptions["reference"]}
                                    option="reference"
                                    updateFilterOptions={props.updateFilterOptions}
                                    availableItems={FILTER_REFERENCE_RANGE_OPTIONS}
                                    setShow={setFilterReferenceShow}
                                />
                            )}
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => props.setShowLabsModal(true)}>
                                Labs {(props.filterOptions["annotations"].length > 0) ? (
                                    <>({props.filterOptions["annotations"].length})</>
                                ) : <></>}{' '}<FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => props.setShowMedsModal(true)}>
                                Meds {(props.filterOptions["annotations"].length > 0) ? (
                                    <>({props.filterOptions["annotations"].length})</>
                                ) : <></>}{' '}<FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                        </div>
                        <div>
                            <Button variant="secondary" size="sm" onClick={() => props.setShowOrdersModal(true)}>
                                Orders{' '}<FontAwesomeIcon icon={faCaretDown} />
                            </Button>
                        </div>
                        <div>
                            <Button className="reset-zoom-btn" size="sm" variant="outline-secondary" onClick={props.doubleClickOnTimeline}>Reset Zoom</Button>
                            <Button className="zoom-btn" size="sm" variant="outline-secondary" onClick={() => props.zoom(true)}><FontAwesomeIcon icon={faPlus} /></Button>
                            <Button className="zoom-btn" size="sm" variant="outline-secondary" onClick={() => props.zoom(false)}><FontAwesomeIcon icon={faMinus} /></Button>
                            <Button size="sm" variant={isFavorite() ? "secondary" : "outline-secondary"} onClick={(e: any) => {
                                e.stopPropagation();
                                props.setShowFavoriteContextMenu(true);
                                props.setFavoriteContextMenu({
                                    x: e.pageX + 16,
                                    y: e.pageY,
                                    patient: props.patientVisit,
                                    listName: null,
                                })
                            }}>
                                {
                                    // @ts-ignore
                                    <FontAwesomeIcon icon={isFavorite() ? faStar : faStarOutline} />
                                }
                            </Button>
                        </div>
                    </ButtonGroup>
                </Col>
            </Row>
        </Container>
    );
};
